/*
  WSS behaviours for Horizon.
  Collection: places the "Is it really 20mm?" fitting tile in the product grid; colour dots in the colour filter.
  Product page:
  - Width guard: without ?variant= the first width isn't treated as chosen. Add to basket reads
    "Choose a width to continue" until one is clicked. The last width chosen is remembered
    (localStorage wss:width) and applied to the next strap, as on the old theme. Arriving from a width
    collection (e.g. 18mm straps) selects that width first.
  - Strap spec strip (moved to sit under the widths), Length/Fitting chips, size guide highlight,
    low-stock line and back-in-stock form follow the chosen width and buckle. Data comes from the JSON
    output by blocks/wss-spec-strip.liquid.
  - "You might also like" gets the add-on tile from sections/wss-addon-tile.liquid.
  Horizon owns the variant picker and product form; this script reads their state and restyles labels.
*/
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var store = {
    get: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };
  // Only write when the text actually changes: every write counts as a change to the watchers below, and
  // rewriting the same text set them off again every 40ms, forever. That constant redraw made the product page
  // jerk about when scrolling, worst after the reviews link (17 Oct, Martyn).
  var setText = function (el, t) { if (el && el.textContent !== t) el.textContent = t; };
  var setHTML = function (el, h) { if (el && el.innerHTML !== h) el.innerHTML = h; };
  var observe = function (el, fn, opts) {
    if (!el || !('MutationObserver' in window)) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(fn, 40); }).observe(el, opts || { childList: true, subtree: true });
  };

  // Size guide tabs (section wss-size-guide)
  $$('[data-wss-sg-tab]').forEach(function (t) {
    t.addEventListener('click', function () {
      var id = t.getAttribute('data-wss-sg-tab');
      $$('[data-wss-sg-tab]').forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      $$('.wss-sgpanel').forEach(function (p) { p.hidden = p.id !== id; });
    });
  });

  // ---- Header mega menu: product counts and a promo tile per menu (from sections/wss-announce.liquid) ----
  var counts = {};
  try { var ce = $('[data-wss-menu-counts]'); if (ce) counts = JSON.parse(ce.textContent); } catch (e) {}
  // Horizon fills the mega menus in when they first open, so decorate on demand as well as at load.
  function megaDecorate() {
    $$('.mega-menu__link:not(.mega-menu__link--parent)').forEach(function (a) {
      var n = counts[a.getAttribute('href')];
      if (!n || $('.wss-mcount', a)) return;
      var c = document.createElement('span'); c.className = 'wss-mcount'; c.textContent = n;
      a.appendChild(c);
    });
    $$('.menu-list__list-item').forEach(function (li) {
      var title = $('.menu-list__link-title', li);
      var grid = $('.mega-menu__grid', li);
      if (!title || !grid || $('.wss-megapromo', grid)) return;
      var tpl = $('template[data-wss-mega-promo="' + CSS.escape(title.textContent.trim().toLowerCase()) + '"]');
      if (tpl) { grid.classList.add('wss-hasmegapromo'); grid.appendChild(tpl.content.firstElementChild.cloneNode(true)); }
    });
  }
  megaDecorate();
  ['pointerover', 'focusin', 'click'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target.closest && e.target.closest('.menu-list__list-item, header-menu, .header')) setTimeout(megaDecorate, 30);
    }, true);
  });

  // ---- Collection ----
  function placePromo() {
    var tpl = $('template[data-wss-promo]');
    var grid = $('ul.product-grid');
    if (!tpl || !grid || $('.wss-promo-tile-item', grid)) return;
    var items = $$(':scope > .product-grid__item', grid);
    var pos = parseInt(tpl.getAttribute('data-position'), 10) || 6;
    if (items.length < pos) return;
    items[pos - 2].insertAdjacentElement('afterend', tpl.content.firstElementChild.cloneNode(true));
  }
  var colourMapEl = $('[data-wss-colour-map]');
  var colourMap = {};
  try { colourMap = colourMapEl ? JSON.parse(colourMapEl.textContent) : {}; } catch (e) {}
  function colourDots() {
    $$('input[name="filter.p.m.custom.product_attribute_strap_colour"]').forEach(function (i) {
      var label = i.closest('label') || (i.id && $('label[for="' + CSS.escape(i.id) + '"]'));
      // Already done? Check the input's own wrapper too: Horizon's pill layout (used when a colour value is a
      // grouped filter value) puts the label beside the input, not round it, and a missed check here made the
      // page add a dot on every redraw, forever (red straps collection, 16 Oct).
      if (!label || $('.wss-fdot', label) || (i.parentElement && $(':scope > .wss-fdot', i.parentElement))) return;
      var hex = colourMap[i.value];
      if (!hex) return;
      var dot = document.createElement('span');
      dot.className = 'wss-fdot';
      dot.style.background = hex;
      // Light colours get a dark tick when chosen.
      var hx = hex.replace('#', '');
      if (hx.length === 6) {
        var lum = 0.299 * parseInt(hx.substr(0, 2), 16) + 0.587 * parseInt(hx.substr(2, 2), 16) + 0.114 * parseInt(hx.substr(4, 2), 16);
        if (lum > 170) dot.classList.add('wss-fdot--light');
      }
      // Always inside the label: in front of its text, or at the start of a pill label (keeps input + label adjacent for the ticked style).
      var text = $('.checkbox__label-text, .facets__label-text', label);
      if (text) text.insertAdjacentElement('beforebegin', dot); else label.insertAdjacentElement('afterbegin', dot);
    });
  }
  // Filter sidebar and phone drawer (16 Oct, Martyn's canvas design "Filters"). Horizon renders every filter
  // as a tick list; each group is given a layout from what it holds, so it works whatever filters Search &
  // Discovery has: colour = swatch grid, buckle = tiles, anything else = pills (a tick list only if a value is long).
  // Also: "Filter straps" header with Clear all, a count of picks on each group heading, price quick buttons,
  // and on phones groups start closed with the picks named under the heading. Horizon still does the filtering.
  var METALS = { silver: '#c9cccc', gold: '#c9a86a', 'rose gold': '#d4a28e', black: '#1a1a1a', gunmetal: '#5b5f63', bronze: '#9a6a3c' };
  var PRICE_BANDS = [['Under £15', null, '14.99'], ['£15 to £25', '15', '25'], ['£25 and over', '25', null]];
  function filterUrl(mut) {
    var p = new URLSearchParams(location.search);
    p.delete('page');
    mut(p);
    var q = p.toString();
    return location.pathname + (q ? '?' + q : '');
  }
  function decorateFilters() {
    $$('.facets__item').forEach(function (item) {
      var param = item.getAttribute('data-filter-param-name') || '';
      // Labels from either of Horizon's layouts: tick boxes, or pills (used for grouped values, e.g. "Red" on the red collection).
      var labels = $$('.checkbox__label-text', item);
      if (!labels.length) labels = $$('.facets__pill-label', item);
      var isPrice = !!$('price-facet-component, .price-facet', item);
      // Layout is fixed per filter, not by how many values a collection happens to have, so every collection's
      // sidebar looks the same (16 Oct, Martyn: Black showed Material as a list, Red as pills).
      var kind = 'chips';
      if (isPrice) kind = 'price';
      else if (/colou?r/.test(param) || $('.wss-fdot', item)) kind = 'swatch';
      else if (/width/.test(param)) kind = 'chips';
      else if (/buckle|availability/.test(param)) kind = 'tiles';
      else if (labels.some(function (l) { return l.textContent.trim().length > 24; })) kind = 'list';
      if (!labels.length && !isPrice) kind = 'other';
      if (item.getAttribute('data-wss-f') !== kind) item.setAttribute('data-wss-f', kind);
      // Metal dot on buckle-type tiles
      if (kind === 'tiles') {
        labels.forEach(function (l) {
          var c = METALS[l.textContent.trim().toLowerCase()];
          var lab = l.closest('.checkbox__label');
          if (c && lab && !$('.wss-fmetal', lab)) {
            var d = document.createElement('span'); d.className = 'wss-fmetal'; d.style.background = c;
            l.insertAdjacentElement('beforebegin', d);
          }
        });
      }
      // Count of picks on the heading, and their names (shown under the heading in the phone drawer)
      var summary = $('.facets__summary', item);
      if (summary) {
        var picked = $$('input:checked', item).map(function (i) {
          var lab = i.id && $('label[for="' + CSS.escape(i.id) + '"]', item);
          var t = lab && $('.checkbox__label-text, .facets__pill-label, .facets__swatch-label', lab);
          return (t || lab || i).textContent.trim() || i.getAttribute('data-label') || i.value;
        });
        var badge = $('.wss-fbadge', summary);
        if (!badge) { badge = document.createElement('span'); badge.className = 'wss-fbadge'; var label = $('.facets__label', summary); (label || summary.firstChild).insertAdjacentElement('afterend', badge); }
        var n = picked.length ? String(picked.length) : '';
        if (badge.textContent !== n) badge.textContent = n;
        if (badge.hidden !== !picked.length) badge.hidden = !picked.length;
        var names = $('.wss-fsel', summary);
        if (!names) { names = document.createElement('span'); names.className = 'wss-fsel'; badge.insertAdjacentElement('afterend', names); }
        var nt = picked.join(', ');
        if (names.textContent !== nt) names.textContent = nt;
        if (names.hidden !== !nt) names.hidden = !nt;
        // Phone drawer: start with groups closed unless something in them is picked
        var details = item.closest('details') || $('details', item);
        if (details && item.closest('.facets--drawer') && !item.hasAttribute('data-wss-folded')) {
          item.setAttribute('data-wss-folded', '');
          if (!picked.length) { details.open = false; item.removeAttribute('open'); }
        }
      }
      // Price quick buttons
      if (kind === 'price') {
        var wrap = $('.price-facet__inputs-wrapper', item) || $('.price-facet', item);
        if (wrap && !$('.wss-pchips', item)) {
          var cur = new URLSearchParams(location.search);
          var gte = cur.get('filter.v.price.gte'), lte = cur.get('filter.v.price.lte');
          var box = document.createElement('div'); box.className = 'wss-pchips';
          PRICE_BANDS.forEach(function (b) {
            var on = (gte || null) === b[1] && (lte || null) === b[2];
            var a = document.createElement('a');
            a.className = 'wss-pchip' + (on ? ' is-on' : '');
            a.textContent = b[0];
            if (on) a.setAttribute('aria-current', 'true');
            a.href = filterUrl(function (p) {
              p.delete('filter.v.price.gte'); p.delete('filter.v.price.lte');
              if (!on) { if (b[1]) p.set('filter.v.price.gte', b[1]); if (b[2]) p.set('filter.v.price.lte', b[2]); }
            });
            box.appendChild(a);
          });
          wrap.insertAdjacentElement('beforebegin', box);
        }
      }
    });
    // "Filter straps" header with Clear all, at the top of the desktop sidebar
    $$('.facets--vertical .facets__form').forEach(function (form) {
      var head = $('.wss-fhead', form);
      if (!head) {
        head = document.createElement('div'); head.className = 'wss-fhead';
        head.innerHTML = '<h2>Filter straps</h2><a class="wss-fhead__clear" hidden>Clear all</a>';
        form.insertAdjacentElement('afterbegin', head);
      }
      var any = /(^|[?&])filter\./.test(location.search) || !!$('input:checked', form);
      var clear = $('.wss-fhead__clear', head);
      if (clear.hidden !== !any) clear.hidden = !any;
      var clearHref = filterUrl(function (p) { Array.from(p.keys()).forEach(function (k) { if (k.indexOf('filter.') === 0) p.delete(k); }); });
      if (clear.getAttribute('href') !== clearHref) clear.setAttribute('href', clearHref);
    });
  }
  // "Showing 24 of 586 straps" + Load more, in place of Horizon's numbered pages (which stay for no-JS and crawlers).
  function nextHref(nav) {
    var arrows = $$('a.pagination__link--arrow[href]', nav);
    var a = arrows.filter(function (x) { return /next/i.test(x.getAttribute('aria-label') || ''); })[0] || arrows[arrows.length - 1];
    if (!a) return null;
    var cur = parseInt(nav.getAttribute('data-current_page'), 10) || 1;
    var m = (a.getAttribute('href') || '').match(/[?&]page=(\d+)/);
    return m && parseInt(m[1], 10) > cur ? a.getAttribute('href') : null;
  }
  function loadMore() {
    var grid = $('ul.product-grid');
    var nav = grid && $('nav.pagination', grid.parentNode);
    if (!grid || !nav || nav.hasAttribute('data-wss-done')) return;
    nav.setAttribute('data-wss-done', '');
    var countEl = $('.products-count-wrapper');
    var total = countEl ? parseInt(countEl.textContent.replace(/[^\d]/g, ''), 10) : 0;
    var box = document.createElement('div');
    box.className = 'wss-loadmore';
    box.innerHTML = '<span class="wss-loadmore__text"></span><span class="wss-loadmore__bar"><span></span></span><button type="button" class="wss-loadmore__btn">Load more straps</button>';
    nav.insertAdjacentElement('afterend', box);
    nav.classList.add('wss-visually-hidden');
    var btn = $('button', box);
    var next = nextHref(nav);
    var section = $('results-list') && $('results-list').getAttribute('section-id');
    // By style with everything loaded: say so plainly and offer every colour, rather than "7 styles of 53 straps"
    // with no button, which read as if straps were missing (17 Oct, Martyn, nylon collection).
    function update() {
      var shown = $$(':scope > .product-grid__item:not(.wss-promo-tile-item)', grid).length;
      var styles = grid.getAttribute('data-wss-view') === 'style';
      var nStyles = $$(':scope > .product-grid__item:not(.wss-promo-tile-item):not(.wss-dup)', grid).length;
      var showAll = styles && !next && total > nStyles;
      var text = !styles
        ? 'Showing ' + shown + (total ? ' of ' + total : '') + ' straps'
        : showAll
          ? 'All ' + nStyles + ' style' + (nStyles === 1 ? '' : 's') + ' shown. With every colour, that’s ' + total + ' straps.'
          : 'Showing ' + nStyles + ' styles' + (total ? ' (' + total + ' straps in all their colours)' : '');
      var el = $('.wss-loadmore__text', box);
      if (el.textContent !== text) el.textContent = text;
      $('.wss-loadmore__bar span', box).style.width = total ? Math.min(100, Math.round(shown / total * 100)) + '%' : '0';
      // Only change what differs: a rewrite here set off the view toggle's watcher, which ran this again, forever (17 Oct).
      if (showAll) { if (!btn.hasAttribute('data-wss-all')) btn.setAttribute('data-wss-all', ''); setText(btn, 'Show all ' + total + ' straps'); if (btn.hidden) btn.hidden = false; }
      else { if (btn.hasAttribute('data-wss-all')) btn.removeAttribute('data-wss-all'); if (!busy) setText(btn, 'Load more straps'); if (btn.hidden !== !next) btn.hidden = !next; }
    }
    document.addEventListener('wss:view', function () { if (!box.isConnected) return; update(); if (visible() < 24) fill(24, false); });
    // Cards showing: in the "By style" view, one per style (other colours of a style already showing don't count).
    function visible() {
      var items = $$(':scope > .product-grid__item:not(.wss-promo-tile-item)', grid);
      if (store.get('wss:view') === 'all' || !$('.wss-view')) return items.length;
      var seen = {};
      items.forEach(function (li) { var g = $('[data-wss-group]', li); seen[g ? g.getAttribute('data-wss-group') : Math.random()] = 1; });
      return Object.keys(seen).length;
    }
    function fetchPage() {
      var url = next + (next.indexOf('?') > -1 ? '&' : '?') + (section ? 'section_id=' + encodeURIComponent(section) : '');
      return fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        $$('ul.product-grid > .product-grid__item', doc).forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
        var nav2 = $('nav.pagination', doc);
        next = nav2 ? nextHref(nav2) : null;
        return new Promise(function (res) { setTimeout(res, 30); });
      });
    }
    // Keep fetching pages until `want` cards are showing (or 8 pages, or no more). In By style, a page of
    // 24 straps can be only a few styles, so on landing it fills up to 24 cards, and each click adds 24 more.
    var busy = false;
    function fill(want, fromClick) {
      if (!next || busy) return;
      busy = true;
      btn.disabled = true; btn.textContent = 'Loading…';
      var pages = 0;
      function step() {
        pages++;
        return fetchPage().then(function () {
          if (next && pages < 8 && visible() < want) return step();
        });
      }
      step().catch(function () { if (fromClick && next) location.href = next; }).then(function () {
        busy = false; btn.disabled = false; btn.textContent = 'Load more straps'; update();
      });
    }
    btn.addEventListener('click', function () {
      if (btn.hasAttribute('data-wss-all')) { var v = $('.wss-view button[value=all]'); if (v) v.click(); return; }
      fill(visible() + 24, true);
    });
    update();
    if (visible() < 24) fill(24, false);
  }
  // Smoother scrolling on collections (Safari especially):
  // - the "how to measure" drawing only plays while it's on screen, three times, then rests on the finished drawing;
  // - hover transitions are off while the page is scrolling, so cards passing under the pointer don't animate mid-scroll.
  //   Only the page's own scrolling counts: a card's image slider scrolls too (hover shows the second photo),
  //   and reacting to that made the photos flicker.
  var calmT = null;
  document.addEventListener('scroll', function (e) {
    var tg = e.target;
    if (tg !== document && tg !== document.documentElement && tg !== document.body && !(tg.classList && tg.classList.contains('page-wrapper'))) return;
    if (!calmT) { var g = $('ul.product-grid'); if (g) g.classList.add('wss-calm'); }
    clearTimeout(calmT);
    calmT = setTimeout(function () { calmT = null; $$('ul.product-grid.wss-calm').forEach(function (g) { g.classList.remove('wss-calm'); }); }, 180);
  }, { capture: true, passive: true });
  // Load each visible card's second photo before it's hovered, so the hover swap doesn't flash an empty frame.
  var preIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      preIO.unobserve(e.target);
      var im = e.target.querySelectorAll('slideshow-slide img')[1];
      if (im && im.loading === 'lazy') im.loading = 'eager';
    });
  }, { rootMargin: '200px 0px' }) : null;
  function watchPreload() {
    if (!preIO || !window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    $$('ul.product-grid product-card:not([data-wss-pre])').forEach(function (c) {
      c.setAttribute('data-wss-pre', '');
      if (c.querySelectorAll('slideshow-slide').length > 1) preIO.observe(c);
    });
  }
  var stillMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var maIO = !stillMotion && 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('is-live', e.isIntersecting); });
  }, { threshold: 0.3 }) : null;
  function watchAnim() {
    if (!maIO) return;
    $$('.wss-ma:not([data-wss-io])').forEach(function (el) {
      el.setAttribute('data-wss-io', '');
      el.addEventListener('animationend', function () { el.classList.remove('is-live'); });
      maIO.observe(el);
    });
  }
  if ($('results-list, .product-grid')) {
    placePromo();
    colourDots(); decorateFilters();
    loadMore();
    watchAnim(); watchPreload();
    observe($('collection-component') || document.body, function () { placePromo(); colourDots(); decorateFilters(); loadMore(); watchAnim(); watchPreload(); });
    document.addEventListener('change', function (e) { if (e.target.closest && e.target.closest('.facets')) setTimeout(decorateFilters, 0); });
  }

  // ---- Product ----
  var dataEl = $('[data-wss-product-data]');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var scope = dataEl.closest('.shopify-section') || document;
  var spec = $('[data-wss-spec]', scope);
  var restock = $('[data-wss-restock]', scope);
  var params = new URLSearchParams(location.search);
  // Only one width (e.g. Garmin 20mm): Horizon shows no buttons to tap, so treat it as chosen (21 Oct).
  var onlyWidth = null;
  if (data.widthName) {
    var ws = data.variants.map(function (v) { return v.width; }).filter(function (w, i, a) { return w && a.indexOf(w) === i; });
    if (ws.length === 1) onlyWidth = ws[0];
  }
  var chosen = params.has('variant') || !data.widthName || !!onlyWidth;

  // Width the shopper arrived from, e.g. /collections/20mm-watch-straps (the page before, or a
  // /collections/20mm-watch-straps/products/... address).
  var fromWidth = null;
  try {
    var here = location.pathname.match(/\/collections\/(\d+mm)-watch-straps\/products\//);
    var ref = document.referrer ? new URL(document.referrer) : null;
    var m = here || (ref && ref.host === location.host && ref.pathname.match(/\/collections\/(\d+mm)-watch-straps(?:\/|$)/));
    if (m) fromWidth = m[1];
  } catch (e) {}

  var crumb = $('[data-wss-crumb]');
  if (crumb && fromWidth && location.pathname.indexOf('/collections/') === -1) {
    crumb.href = '/collections/' + fromWidth + '-watch-straps';
    crumb.textContent = fromWidth + ' Watch Straps';
  }
  $$('[data-wss-open-reviews]').forEach(function (a) {
    a.addEventListener('click', function () { var d = $('#wss-allreviews'); if (d) d.open = true; });
  });

  function widthFieldset() {
    var input = data.widthName && $('variant-picker input[data-option-name="' + CSS.escape(data.widthName) + '"]', scope);
    return input ? input.closest('fieldset') : null;
  }
  function checkedValue(name) {
    if (!name) return null;
    var el = $('variant-picker input[data-option-name="' + CSS.escape(name) + '"]:checked', scope);
    if (el) return el.value;
    var sel = $('variant-picker select[data-option-name="' + CSS.escape(name) + '"], variant-picker select[name="options[' + name + ']"]', scope);
    return sel ? sel.value : null;
  }
  function current() {
    var w = chosen ? (checkedValue(data.widthName) || onlyWidth) : null;
    var b = checkedValue(data.buckleName);
    var v = null;
    // No strap-width option (e.g. Apple straps): use the variant Horizon has selected, so stock follows the size
    // picked (it read the first size before, 17 Oct).
    if (!data.widthName) {
      var idEl = $('product-form-component [name="id"], form[action*="/cart/add"] [name="id"]', scope);
      var vid = idEl ? parseInt(idEl.value, 10) : 0;
      v = data.variants.find(function (x) { return x.id === vid; }) || data.variants.find(function (x) { return !data.buckleName || x.buckle === b; }) || data.variants[0];
    }
    else if (w) v = data.variants.find(function (x) { return x.width === w && (!data.buckleName || x.buckle === b); });
    return { width: w, buckle: b, variant: v || null };
  }

  // Width label and the "How to measure" link (Horizon re-renders the picker, so re-apply).
  // The spec strip sits between Width and Buckle through CSS order (see wss.css, product page).
  function decorate(s) {
    var fs = widthFieldset();
    if (fs) {
      fs.classList.add('wss-widthset');
      fs.toggleAttribute('data-wss-unchosen', !chosen);
      var legend = $('legend', fs);
      if (legend) {
        var note = $('.wss-legend-note', legend);
        if (!note) { note = document.createElement('span'); note.className = 'wss-legend-note'; legend.appendChild(note); }
        setText(note, chosen && s.width ? ': ' + s.width : ': choose one');
        note.classList.toggle('is-warn', !(chosen && s.width));
        if (data.guideUrl && !$('.wss-measure', legend)) {
          var a = document.createElement('a'); a.className = 'wss-measure'; a.href = data.guideUrl; a.textContent = 'How to measure';
          legend.appendChild(a);
        }
      }
      var msg = $('.wss-guard-msg', scope);
      if (chosen && msg) msg.remove();
    }
    if (data.buckleName) {
      var bi = $('variant-picker input[data-option-name="' + CSS.escape(data.buckleName) + '"]', scope);
      var bfs = bi && bi.closest('fieldset');
      if (bfs) bfs.classList.add('wss-buckleset');
    }
  }

  function setButton(s) {
    var btn = $('product-form-component button[name="add"]', scope);
    if (!btn) return;
    var form = btn.closest('product-form-component');
    // The label is either a span or a bare text node inside the button.
    var label = $('.add-to-cart-text__content > span:first-child', btn);
    if (!label) {
      for (var i = 0; i < btn.childNodes.length; i++) {
        var n = btn.childNodes[i];
        if (n.nodeType === 3 && n.nodeValue.trim()) { label = n; break; }
      }
    }
    var need = !chosen || !s.width;
    form.toggleAttribute('data-wss-needwidth', need && !!data.widthName);
    if (!label) return;
    var text;
    if (need && data.widthName) text = 'Choose a width to continue';
    else if (s.variant && s.variant.available) text = 'Add to basket — ' + s.variant.price;
    else return;
    if (label.textContent.trim() !== text) label.textContent = ' ' + text + ' ';
  }
  // The sticky bar that appears once the main button scrolls away says the same thing. Its button
  // clicks the main one, so the width guard below still applies.
  function setSticky(s) {
    var st = $('sticky-add-to-cart');
    if (!st || !data.widthName) return;
    var need = !chosen || !s.width;
    st.toggleAttribute('data-wss-needwidth', need);
    var lbl = $('.add-to-cart-text__content > span:first-child', st);
    var vt = $('.sticky-add-to-cart__variant', st);
    var text = need ? 'Choose a width' : 'Add to basket';
    if (lbl && lbl.textContent.trim() !== text) lbl.textContent = text;
    if (vt) {
      var vtext = need ? 'Width not chosen yet' : [s.width, s.buckle].filter(Boolean).join(' / ');
      if (vt.textContent.trim() !== vtext) vt.textContent = vtext;
    }
  }

  function render() {
    var s = current();
    decorate(s);
    setButton(s);
    setSticky(s);

    if (spec) {
      var sz = s.width && data.sizes[s.width];
      // Hide the strip when there's no length data for this strap (e.g. Garmin), or none for the width chosen (21 Oct).
      var hasSizes = !!data.sizes && Object.keys(data.sizes).length > 0;
      var showSpec = hasSizes && (!s.width || !!sz);
      spec.style.display = showSpec ? '' : 'none';
      spec.classList.toggle('is-set', !!sz);
      $('[data-wss-spec-set]', spec).hidden = !sz;
      $('[data-wss-spec-empty]', spec).hidden = !!sz;
      if (sz) {
        setHTML($('[data-wss-spec-len]', spec), '<strong>' + sz.total + 'mm long</strong>' + (sz.c ? ' (' + sz.c + ' + ' + sz.d + 'mm)' : ''));
        setText($('[data-wss-spec-taper]', spec), sz.b ? 'Narrows to ' + sz.b + 'mm at the buckle' : 'Same width at the buckle');
      }
      var hint = $('[data-wss-spec-hint]', spec);
      if (hint) {
        var offers = fromWidth && data.variants.some(function (v) { return v.width === fromWidth; });
        hint.hidden = !offers;
        if (offers) setText(hint, s.width === fromWidth
          ? 'Set to ' + fromWidth + ' as you came from ' + fromWidth + ' straps.'
          : "You came from " + fromWidth + " straps, so it's probably " + fromWidth + '.');
      }
    }
    $$('[data-wss-sg-row]').forEach(function (r) { r.classList.toggle('is-sel', r.getAttribute('data-wss-sg-row') === s.width); });

    $$('[data-wss-sib]', scope).forEach(function (a) {
      var sib = data.siblings[a.getAttribute('data-wss-sib')];
      var small = $('small', a);
      if (!sib || !small) return;
      if (a.getAttribute('aria-current') === 'page') { setText(small, 'This strap'); return; }
      if (!s.width) { setText(small, ''); a.classList.remove('is-na'); if (a.getAttribute('href') !== sib.url) a.href = sib.url; return; }
      var matches = sib.variants.filter(function (x) { return x.o1 === s.width; });
      var hit = matches.find(function (x) { return x.o2 === s.buckle; }) || matches[0];
      var len = sib.sizes && sib.sizes[s.width] && sib.sizes[s.width].total;
      a.classList.toggle('is-na', !hit);
      setText(small, hit ? (len ? len + 'mm long' : 'Available') : 'Not in ' + s.width);
      var href = hit ? sib.url + '?variant=' + hit.id : sib.url;
      if (a.getAttribute('href') !== href) a.href = href;
    });

    var buy = $('.buy-buttons-block', scope);
    var out = !!(s.variant && !s.variant.available);
    if (restock && !$('[role=status]', restock)) {
      if (restock.hidden !== !out) restock.hidden = !out;
      if (out) {
        setText($('[data-wss-restock-title]', restock), 'Sold out in ' + s.variant.title + '.');
        var tags = $('[data-wss-restock-tags]', restock); if (tags && tags.value !== 'restock,restock-' + s.variant.id) tags.value = 'restock,restock-' + s.variant.id;
      }
    } else if (restock) {
      if (restock.hidden) restock.hidden = false;
      out = true;
    }
    if (buy) buy.classList.toggle('wss-hide', out);

    var low = $('.wss-low-stock', scope);
    var v2 = s.variant;
    // Stock line (17 Oct, Martyn): no counts unless it's nearly gone. "In stock" for 3 or more (or untracked),
    // "Only 2 left in 38mm" for 1 or 2. Sold out shows the back-in-stock form instead.
    var inStock = !!(chosen && v2 && v2.available);
    var few = inStock && v2.tracked && v2.qty > 0 && v2.qty < 3;
    var lowText = few ? 'Only ' + v2.qty + ' left in ' + (s.width || v2.title) : (inStock ? 'In stock' : '');
    if (buy) {
      if (!low && lowText) { low = document.createElement('p'); low.className = 'wss-low-stock'; low.setAttribute('role', 'status'); buy.insertAdjacentElement('beforebegin', low); }
      if (low) { setText(low, lowText); if (low.hidden !== !lowText) low.hidden = !lowText; low.classList.toggle('is-ok', inStock && !few); }
    }
  }
  // Size guide width chips ("Every width in one table") also pick that width in the real picker,
  // so the basket matches what the guide shows (21 Oct: shoppers tapped 16mm in the guide and got 8mm).
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-wss-sg-w]');
    if (!chip || !data.widthName) return;
    var w = chip.getAttribute('data-wss-sg-w');
    var r = $('variant-picker input[data-option-name="' + CSS.escape(data.widthName) + '"][value="' + CSS.escape(w) + '"]', scope);
    if (!r || r.disabled) return;
    chosen = true;
    store.set('wss:width', w);
    if (!r.checked) r.click();
    setTimeout(render, 0);
  });
  // A click on any width counts as choosing it, even the one Horizon preselected.
  scope.addEventListener('click', function (e) {
    if (!data.widthName) return;
    var input = e.target.closest && e.target.closest('variant-picker input[data-option-name="' + CSS.escape(data.widthName) + '"]');
    if (!input) {
      var label = e.target.closest && e.target.closest('variant-picker label');
      if (label) input = $('input[data-option-name="' + CSS.escape(data.widthName) + '"]', label);
    }
    if (!input) return;
    chosen = true;
    store.set('wss:width', input.value);
    setTimeout(render, 0);
  }, true);
  scope.addEventListener('change', function () { setTimeout(render, 0); });
  // Horizon morphs the picker and the buy buttons after each change; re-apply once they settle.
  observe($('variant-picker', scope), render, { subtree: true, childList: true, attributes: true, attributeFilter: ['checked'] });
  observe($('.buy-buttons-block', scope), function () { setButton(current()); }, { subtree: true, childList: true, characterData: true });
  observe($('sticky-add-to-cart'), function () { setSticky(current()); }, { subtree: true, childList: true, characterData: true });

  // Block Add to basket (including the sticky bar) until a width is chosen.
  document.addEventListener('click', function (e) {
    if (chosen) return;
    var btn = e.target.closest && e.target.closest('button[name="add"], .sticky-add-to-cart__button');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var fs = widthFieldset();
    if (fs) {
      var msg = $('.wss-guard-msg', scope);
      if (!msg) { msg = document.createElement('p'); msg.className = 'wss-guard-msg'; msg.setAttribute('role', 'alert'); (spec || fs).insertAdjacentElement('afterend', msg); }
      msg.textContent = 'Please choose a width to continue.';
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

  // Width preselect (as on the live theme). Coming from a width collection (e.g. 18mm straps) selects
  // that width if this strap comes in it, even if it's sold out there (the back-in-stock form then shows).
  // Otherwise the last width chosen is used if this strap has it in stock.
  if (!chosen) {
    var want = null;
    if (fromWidth && data.variants.some(function (v) { return v.width === fromWidth; })) {
      want = fromWidth;
      store.set('wss:width', fromWidth);
    } else {
      var last = store.get('wss:width');
      if (last && data.variants.some(function (v) { return v.width === last && v.available; })) want = last;
    }
    if (want) {
      var r = $('variant-picker input[data-option-name="' + CSS.escape(data.widthName) + '"][value="' + CSS.escape(want) + '"]', scope);
      if (r) {
        chosen = true;
        if (!r.checked) r.click();
      }
    }
  }

  // Colour links keep the chosen width.
  $$('[data-wss-keep-width]', scope).forEach(function (a) {
    a.addEventListener('click', function () { var w = checkedValue(data.widthName); if (chosen && w) store.set('wss:width', w); });
  });

  // Add-on tile at the end of "You might also like".
  function placeAddon() {
    var tpl = $('template[data-wss-addon]');
    var grid = $('product-recommendations ul, product-recommendations .resource-list');
    if (!tpl || !grid || $('.wss-addon-item', grid)) return;
    grid.appendChild(tpl.content.firstElementChild.cloneNode(true));
  }
  var recs = $('product-recommendations');
  if (recs) { placeAddon(); observe(recs, placeAddon); }

  render();
})();
